<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
    <b-card>
      <b-row>
        <b-col cols="12">
            <b-card>
              <b-row class="m-0 p-0" style="color: var(--color-dentalia); font-size: 20px; font-weight: bold; border-bottom: 3px solid; border-color: rgb(68, 173, 248); !important">
                <b-col class="text-left m-0 p-0">
                  <span>
                    Administración de pacientes con plan/convenio
                  </span>
                </b-col>
                <b-col class="text-right m-0 p-0">
                  <div>Admin_Plan_Convenio</div>
                </b-col>
              </b-row>
              <b-card-body>
                <!-- Busqueda de paciente  -->

                <!--   -->
                <b-row>
                  <b-col>
                    <br />
                  </b-col>
                </b-row>
                <!--   -->

                  <b-tabs>
                    <b-tab title="Plan" v-if="$localStorageService.can('PC_01_Px_asigPlan')" active @click="opcion(1)">
                      <b-row>
                        <b-col v-if="datosCita != undefined && datosCita != null"
                              cols="7">
                          <cardPaciente style="margin-left: 80px;" :patInfo="datosCita" :mostrarDetalle="!mostrarBarraBusqueda"></cardPaciente>
                        </b-col>
                        <b-col style="padding: 15px">
                          <b-row :style="datosCita!=null?'width: 90%;':'width: 80%;margin: auto;'">
                            <b-col cols="12" style="display: flex">
                              <div style="min-width: 350px; flex: 1;margin-right: 0px; margin-top: 0px;"
                                  :style="datosCita!=null?'width: 100%;margin-left:0px;margin-top:0px':''"
                                  >
                                <div class="barra-plan" style="margin-top: 10px;" :style="datosCita != undefined && datosCita != null ? 'margin-left:0px; margin-right:0px;':''">
                                  <div style="flex:1; display: flex;" >
                                    <div style="display: contents;">
                                        <b-form-input
                                            class="input-filter"
                                            v-model="nombrePacienteBusqueda"
                                            placeholder="Búsqueda de paciente por nombre o ID"
                                            type="text"
                                            @keydown.enter.prevent="buscarPacientes()"
                                        ></b-form-input>

                                        <b-button size="sm"
                                                  variant="info"
                                                  :disabled="loadingPacientes || validarInputBusqueda()"
                                                  style="margin: auto;"
                                                  @click="buscarPacientes()">
                                          <span v-if="!loadingPacientes"><em class="buscar_svg" style="height: 16px;"></em></span>
                                          <span v-else><b-spinner small></b-spinner></span>
                                        </b-button>
                                    </div>
                                  </div>
                                </div>
                                <validacion style="font-size: 10px;text-align: center;display: block;"
                                            v-if="validarInputBusqueda()"
                                            texto="No se pueden buscar letras y numeros al mismo tiempo" />
                              </div>
                              <b-button-group style="display: flex; margin: auto;">
                                <b-button class="button-dentalia-svg-1 ml-2 mt-2" variant="primary"
                                          title="Asignación de plan a px"
                                          v-if="form.idPaciente != null"
                                          @click="asignacionPlanModal = true; editar = false; limpiarFormulario()"
                                          style="width: 38px; height: 38px;"
                                >
                                  <em class="diente_tabla_svg" style="width: 25px; height: 25px;"></em>
                                </b-button>
                              </b-button-group>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                      <div align="center" v-if="!loadingPacientes && registros != null">
                        <b-table
                            :items="registros"
                            :fields="columnasPacientesEncontrados"
                            :hover="true"
                            :small="true"
                            responsive
                            fixed
                            show-empty
                            class="contenedorTablaSinColor"
                            @row-clicked="seleccionarPaciente"
                            style="width: 45%;"
                        >
                          <template #empty="scope">
                              <b-alert show variant="warning">No hay datos</b-alert>
                          </template>
                          <template v-slot:cell(fechaNacimiento)="row">
                            {{ row.item.fechaNacimiento | formatoFechaCortaDMA }}
                          </template>
                        </b-table>

                      </div>
                      <b-row>
                        <b-col>
                          <b-row class="contenedorTablaSinColor">
                            <b-col>
                              <br />
                              <b-table
                                thead-tr-class="columnasTablaSinColor"
                                :items="listaPlanesPaciente"
                                :fields="encabezadosPlanesPaciente"
                                responsive
                              >
                              <template v-slot:cell(nombrePlan)="row">
                                  <div class="d-flex flex-column align-items-center">
                                    <div  class="text-center" v-b-tooltip.hover.topright.v-light title="Este plan no requiere herramientas de diagnóstico" v-if="buscarPlanSinHerramientas(row.item.idPlan) && row.item.registroActivoPlan && row.item.registroActivoPacientePlan && !row.item.suspendidoPlan && planEstaVigente(row.item.inicioVigenciaPlan, row.item.finvigenciaPlan)" style="min-width: 80px; background-color: #E5E7E7; border-radius: 50px; color: #7E7E7E; padding: 2px 5px; font-weight: 600; width: 50px;">
                                      <p class="p-0 m-0">PRESUNTIVO</p>
                                    </div>
                                    <p class="m-0 p-0">{{ row.item.nombrePlan }}</p>
                                  </div>
                                </template>
                                <template v-slot:cell(inicioVigenciaPlan)="row">
                                  <div>
                                    {{
                                      row.item.inicioVigenciaPlan
                                        | formatoFechaHora
                                    }}
                                  </div>
                                </template>
                                <template v-slot:cell(finvigenciaPlan)="row">
                                  <div>
                                    {{
                                      row.item.finvigenciaPlan | formatoFechaHora
                                    }}
                                  </div>
                                </template>

                                <template v-slot:cell(registroActivoPlan)="row">
                                  <p v-if="row.item.registroActivoPlan" style="color: rgb(4, 196, 4);  font-weight: bold;">Activo</p>
                                  <p v-else style="color: grey;  font-weight: bold;">Inactivo</p>
                                </template>
                                
                                <template v-slot:cell(suspendidoPlan)="row">
                                  <p v-if="row.item.suspendidoPlan" style="color: rgb(4, 196, 4); font-weight: bold;">Sí</p>
                                  <p v-else style="color: grey;  font-weight: bold;">No</p>
                                </template>
                
              
              
          
                                <template v-slot:cell(vigenciaSeleccionada)="row">
                                  <div
                                    v-if="row.item.vigenciaSeleccionada == null"
                                  >
                                    <b-alert variant="danger" size="sm" show
                                      >Vigencia no seleccionada</b-alert
                                    >
                                  </div>
                                  <div v-else>
                                    {{ row.item.vigenciaSeleccionada }}
                                  </div>
                                </template>
                                <template v-slot:cell(aplicarDescuento)="row">
                                  <div
                                    v-if="row.item.vigenciaSeleccionada == null"
                                  >
                                    <b-alert variant="danger" size="sm" show
                                      >Vigencia no seleccionada</b-alert
                                    >
                                  </div>
                                  <div v-else>
                                    <p v-if="row.item.aplicarDescuento" style="color: rgb(5, 75, 156); font-weight: bold;">Si</p>
                                    <p v-else style="color: rgb(189, 196, 10);  font-weight: bold;">No</p>
                                  </div>
                                </template>

                                <template v-slot:cell(acciones)="row"> 
                                  <div v-if="row.item.registroActivoPlan == false">
                                    Plan Inactivo
                                  </div>
                                  <div v-else class="row">
                                    <b-button
                                      v-if="$localStorageService.can('PC_01_Px_bt_edit_px')"
                                      size="sm" variant="warning" class="mt-1 marginbotones "
                                      style="border-radius:15px; width: 30%;"
                                      :disabled="
                                        //row.item.idCoberturaPlan == 8
                                        (proceso == 1 && row.item.idTipoAsegurado == null) ||
                                        (proceso == 2 && row.item.idTipoAsegurado !== null )
                                      "
                                      @click="editarPlanPaciente(row.item.id)"
                                      ><em class="editar_svg sm"></em>
                                    </b-button>
                                    <b-button
                                      variant="danger" size="sm" class="mt-1 marginbotones "
                                      style="border-radius:15px; width: 31%;"
                                      v-if="$localStorageService.can('PC_01_Px_bt_inac_px') && row.item.registroActivoPacientePlan"
                                      @click="cambiarEstatusPlanPaciente(row.item.idPlanPaciente,false)"
                                      ><em class="desactivo-rojo-svg md" style="width: 22px; height: 100%; margin-right: 3px; padding-right: 6px;"></em>
                                    </b-button>
                                    <b-button
                                      size="sm" variant="success" class="mt-1 marginbotones "
                                      style="border-radius:15px; width: 30%;"
                                      v-else-if="$localStorageService.can('PC_01_Px_bt_inac_px')"
                                      @click="cambiarEstatusPlanPaciente(row.item.idPlanPaciente,true)"
                                      ><em class="activo-verde-svg sm" style="width: 22px; height: 100%; margin-right: 3px; padding-right: 6px;"></em>
                                    </b-button>
                                    <b-button
                                      v-if="$localStorageService.can('PC_01_Px_bt_edit_px')"
                                      size="sm" variant="primary" class="mt-1 marginbotones "
                                      style="border-radius:15px; width: 30%;"
                                      v-b-popover.hover.topright="'Ver detalle'"
                                      v-b-toggle="'collapseDetalle-'"
                                      >
                                      <em
                                        @click="mandarDatos(row.item)"
                                        class="ojo_svg sm"></em>
                                    </b-button>
                                  </div>
                                </template>
                              </b-table>
                              <div align="center">
                                <b-tr :key="'collapseDetalle-'">
                                  <b-td v-if="plan != null" class="contenedorTablaSinColor">
                                    <b-collapse :id="'collapseDetalle-'" :accordion="'my-accordion'">
                                      <div class="contenedorTablaPrecio text-left m-2 p-2">
                                        <p style="font-weight: bold">Detalle del registro</p>
                                        <b-table-simple class="text-center">
                                          <b-thead>
                                            <b-tr>
                                              <b-th>Fecha inicio de vigencia</b-th>
                                              <b-th>Fecha fin de vigencia</b-th>
                                              <b-th>Fecha inicio de vigencia plan</b-th>
                                              <b-th>Fecha fin de vigencia plan</b-th>
                                              <b-th>Fecha de modificación</b-th>
                                              <b-th>Usuario de modificación</b-th>
                                            </b-tr>
                                          </b-thead>
                                          <b-tbody>
                                            <b-tr>
                                              <b-td v-if="plan != null">{{plan.inicioVigenciaPaciente}}</b-td>
                                              <b-td v-if="plan != null">{{plan.finvigenciaPaciente}}</b-td>
                                              <b-td v-if="plan != null">{{plan.inicioVigenciaPlan}}</b-td>
                                              <b-td v-if="plan != null">{{plan.finvigenciaPlan}}</b-td>
                                              <b-td v-if="plan != null">{{plan.fechaModificacion | formatoFechaHora}}</b-td>
                                              <b-td v-if="plan != null">{{ plan.nombreUsuarioModificacion }}</b-td>
                                            </b-tr>
                                          </b-tbody>
                                        </b-table-simple>
                                      </div>
                                    </b-collapse>
                                  </b-td>
                                </b-tr>
                              </div>
                            
                              <b-col v-if="!loadingPacientes">
                                <div style="height: 10rem;" v-if="listaPlanesPaciente.length === 0 && pacSelTmp == null" show>
                                  <br>
                                  <br>
                                  <p style="font-weight: bold; font-size: 12px;">Aún no se selecciona ningún paciente</p>
                                </div>
                                <div style="height: 10rem;" v-if="listaPlanesPaciente.length === 0 && pacSelTmp != null" show>
                                  <br>
                                  <br>
                                  <p style="font-weight: bold; font-size: 12px;">No se encontraron planes del paciente</p>
                                </div>
                              </b-col>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col
                              align="center"
                              v-if="form.idPaciente != null && spinner"
                            >
                              <b-spinner
                                variant="primary"
                                label="Spinning"
                              ></b-spinner>
                            </b-col>
                          </b-row>
                          
                          <b-modal
                          size="lg"
                          v-model="asignacionPlanModal"
                          hide-header
                          hide-footer>
                          <b-row class="ml-1">
                            <em class="tabla_diente_svg" style="width: 25px; height: 25px;"></em>
                            <p style="color: #092d3e; font-weight: bold;">Asignación Plan</p>
                          </b-row>
                          <b-row class="ml-1">
                            <b-col>
                              <p v-if="pacSelTmp != null" style="color: #1B81AF;">Asignación de plan a {{ pacSelTmp.nombre }}</p>
                            </b-col>
                            <b-col align="right">
                              <b-button
                                class="button-dentalia-svg-2 ml-2 mt-2"
                                style="width: 34px; height: 34px;"
                                title="Limpiar Formulario"
                                @click="limpiarFormulario()"
                                ><em class="limpiar_svg" style="width: 16px; height: 16px;"></em>
                              </b-button>
                              <b-button class="button-dentalia-svg-2 ml-2 mt-2"
                                style="width: 34px; height: 34px;"
                                title="Agregar nuevo paciente"
                              >
                                <router-link
                                    :to="{ name: 'PacienteCu'  }" >
                                  <em class="nuevo_usuario_svg" style="width: 16px; height: 16px;"></em>
                                </router-link>
                              </b-button>
                            </b-col>
                          </b-row>
                            <b-row>
                              <b-col align="left">
                                <validation-observer
                                  ref="observer"
                                  v-slot="{ handleSubmit }"
                                >
                                  <b-form
                                    @submit.stop.prevent="
                                      handleSubmit(guardarPlanPaciente)
                                    "
                                  >
                                    <b-row>
                                      <b-col>
                                        <validation-provider
                                          name="tipoAsegurado"
                                          :rules="{ required: true }"
                                          v-slot="motivoSlot"
                                        >
                                          <label>Tipo de asegurado:</label>
                                          <validacion>*</validacion> 
                                          <v-select
                                          label="descripcion"
                                          id="id_tipo_asegurado"
                                          v-model="tipoAsegurado"
                                          :options="listaTipoAsegurado"
                                          @input="
                                            seleccinarTipoAsegurado($event)
                                          "
                                          required
                                          :state="
                                              motivoSlot.errors[0]
                                                ? false
                                                : motivoSlot.valid
                                                ? true
                                                : null
                                          ">
                                            <span slot="no-options"
                                              >No hay datos...</span
                                            >
                                          </v-select> 
                                          <validacion
                                            :texto="
                                              motivoSlot.errors[0]
                                                ? motivoSlot.errors[0]
                                                : ''
                                            "
                                          ></validacion>
                                        </validation-provider> 
                                      </b-col>

                                      <b-col>
                                        <validation-provider
                                          name="compania"
                                          :rules="{ required: true }"
                                          v-slot="motivoSlot"
                                        >
                                          <label>Compañia </label
                                          ><validacion>*</validacion>
                                          <v-select
                                            label="nombreComercial"
                                            id="compania"
                                            v-model="compania"
                                            :options="lstCompania"
                                            @input="seleccinarEmpresa($event)"
                                            required
                                            :disabled="editar == true"
                                            :state="
                                              motivoSlot.errors[0]
                                                ? false
                                                : motivoSlot.valid
                                                ? true
                                                : null
                                            "
                                          >
                                            <span slot="no-options"
                                              >No hay datos...</span
                                            >
                                          </v-select>

                                          <validacion
                                            :texto="
                                              motivoSlot.errors[0]
                                                ? motivoSlot.errors[0]
                                                : ''
                                            "
                                          ></validacion>
                                        </validation-provider>
                                      </b-col> 
                                      
                                      <b-col>
                                        <validation-provider
                                          name="plan_convenio"
                                          :rules="{ required: true }"
                                          v-slot="motivoSlot"
                                        >
                                          <label>Plan</label
                                          ><validacion>*</validacion>
                                          <v-select
                                            label="nombrePlan"
                                            id="plan_convenio"
                                            v-model="planConvenio"
                                            :options="lstPlanesConvenios"
                                            @input="
                                              seleccinarPlanConvenio($event)
                                            "
                                            required
                                            :disabled="
                                              plan_convenio == false ||
                                              editar == true
                                            "
                                            :state="
                                              motivoSlot.errors[0]
                                                ? false
                                                : motivoSlot.valid
                                                ? true
                                                : null
                                            "
                                          >
                                            <span slot="no-options"
                                              >No hay datos...</span
                                            >
                                          </v-select>
                                          <validacion
                                            :texto="
                                              motivoSlot.errors[0]
                                                ? motivoSlot.errors[0]
                                                : ''
                                            "
                                          ></validacion>
                                        </validation-provider>
                                      </b-col>
                                    </b-row>

                                    <b-row>
                                      <b-col>
                                        <p></p>
                                      </b-col>
                                    </b-row>
                                    <b-row>
                                      <b-col>
                                        <b-form-group align="left">
                                          <label for="numero_poliza"
                                            >Número de póliza</label
                                          >
                                          <b-input-group
                                            size="sm"
                                            class="mb-2"
                                          >
                                            <b-form-input
                                              id="numero_poliza"
                                              name="numero_poliza"
                                              placeholder="Número de póliza"
                                              v-model="form.numeroPoliza"
                                            ></b-form-input>
                                          </b-input-group>
                                        </b-form-group>
                                      </b-col>
                                      <b-col>
                                        <b-form-group align="left">
                                          <label for="numero_certificado"
                                            >Número de certificado
                                            </label
                                          >
                                          <b-input-group
                                            size="sm"
                                            class="mb-2"
                                          >
                                            <b-form-input
                                              id="numero_certificado"
                                              name="numero_certificado"
                                              placeholder="Número de certificado"
                                              v-model="form.numeroCertificado"
                                            ></b-form-input>
                                          </b-input-group>
                                        </b-form-group>
                                      </b-col>
                                      <b-col></b-col>
                                    </b-row>
                                    <b-row>
                                      <b-col>
                                        <label for="vigencia">Vigencia</label
                                        >
                                      </b-col>
                                    </b-row>
                                    <b-row>
                                      <b-col>
                                        <validation-provider
                                          name="vigencia_inicio"
                                          :rules="{ required: true }"
                                          v-slot="motivoSlot"
                                        >
                                          <b-form-group inline align="left">
                                            Desde <validacion>*</validacion>
                                            <b-input-group
                                              size="sm"
                                              class="mb-2"
                                            >
                                              <b-form-datepicker
                                                id="vigencia_inicio"
                                                name="vigencia_inicio"
                                                placeholder="Fecha inicio"
                                                v-model="inicioVigencia"
                                                :state="
                                                  motivoSlot.errors[0]
                                                    ? false
                                                    : motivoSlot.valid
                                                    ? true
                                                    : null
                                                "
                                              ></b-form-datepicker>
                                            </b-input-group>
                                          </b-form-group>

                                          <validacion
                                            :texto="
                                              motivoSlot.errors[0]
                                                ? motivoSlot.errors[0]
                                                : ''
                                            "
                                          ></validacion>
                                        </validation-provider>
                                      </b-col>
                                      <b-col>
                                        <validation-provider
                                          name="vigencia_fin"
                                          :rules="{ required: true }"
                                          v-slot="motivoSlot"
                                        >
                                          <b-form-group>
                                            Hasta <validacion>*</validacion>
                                            <b-input-group
                                              size="sm"
                                              class="mb-2"
                                            >
                                              <b-form-datepicker
                                                id="vigencia_fin"
                                                name="vigencia_fin"
                                                placeholder="Fecha fin"
                                                v-model="finVigencia"
                                                required
                                                :state="
                                                  motivoSlot.errors[0]
                                                    ? false
                                                    : motivoSlot.valid
                                                    ? true
                                                    : null
                                                "
                                              ></b-form-datepicker>
                                            </b-input-group>
                                          </b-form-group>

                                          <validacion
                                            :texto="
                                              motivoSlot.errors[0]
                                                ? motivoSlot.errors[0]
                                                : ''
                                            "
                                          ></validacion>
                                        </validation-provider>
                                      </b-col>
                                    </b-row>

                                    <br />
                                    <b-row align="center">
                                      <b-col align="right" class="mr-3">
                                        <div v-if="!editar">
                                          <b-button
                                            pill
                                            variant="primary"
                                            type="submit"
                                            v-if="!existePlan"
                                            >Guardar</b-button
                                          >
                                          <b-alert
                                            show
                                            variant="danger"
                                            v-else
                                            >El paciente ya cuenta con el plan
                                            seleccionado</b-alert
                                          >
                                        </div>
                                        <div v-else>
                                          <b-button
                                            variant="success"
                                            pill
                                            type="submit"
                                            >Editar</b-button
                                          >
                                        </div>
                                      </b-col>
                                      <b-col align="left" class="ml-3">
                                        <b-button
                                            pill
                                            variant="secondary"
                                            @click="asignacionPlanModal = false"
                                            >cancelar</b-button
                                          >
                                      </b-col>
                                    </b-row>
                                    <br />
                                  </b-form>
                                </validation-observer>
                              </b-col>
                            </b-row>
                          </b-modal>
                        </b-col>
                      </b-row>
                    </b-tab>
                    <b-tab title="Beneficio Dental" v-if="$localStorageService.can('PC_01_Px_asigCon')" @click="opcion(2)">
                      <!-- Asignación convenio  -->
                      <b-row>
                        <b-col>
                          <b-card
                            header="Asignación Beneficio"
                            header-tag="header"
                            title=""
                            align="left"
                          >
                            <b-card-body>
                              <b-row>
                                <b-col align="left">
                                  <validation-observer
                                    ref="observer"
                                    v-slot="{ handleSubmit }"
                                  >
                                    <b-form
                                      @submit.stop.prevent="
                                        handleSubmit(guardarPlanPaciente)
                                      "
                                    >
                                      <b-row>
                                        <b-col>
                                          <validation-provider
                                            name="idpat"
                                            :rules="{ required: true }"
                                            v-slot="motivoSlot"
                                          >
                                            <b-form-group align="left">
                                              <label for="id_paciente"
                                                >Id Paciente</label
                                              ><validacion>*</validacion>
                                              <b-input-group
                                                size="sm"
                                                class="mb-2"
                                              >
                                                <b-input-group-prepend is-text>
                                                  <b-icon
                                                    icon="person"
                                                  ></b-icon>
                                                </b-input-group-prepend>
                                                <b-form-input
                                                  id="id_paciente"
                                                  name="id_paciente"
                                                  placeholder="Id Paciente"
                                                  v-model="form.idPaciente"
                                                  disabled
                                                  :state="
                                                    motivoSlot.errors[0]
                                                      ? false
                                                      : motivoSlot.valid
                                                      ? true
                                                      : null
                                                  "
                                                ></b-form-input>
                                              </b-input-group>
                                            </b-form-group>

                                            <validacion
                                              :texto="
                                                motivoSlot.errors[0]
                                                  ? motivoSlot.errors[0]
                                                  : ''
                                              "
                                            ></validacion>
                                          </validation-provider>
                                        </b-col>
                          
                                        <b-col>
                                          <b-form-group align="left">
                                            <label>Buscar número de certificado:</label> 
                                            <b-input-group size="sm" class="mb-2" id="certificadoBusq" lab>
                                              <b-input-group-prepend is-text>
                                                <b-icon icon="search"></b-icon>
                                              </b-input-group-prepend>
                                              <b-form-input name="certificado"
                                                            v-model="certificado" @keydown.enter.native="obtenerCertificado()"
                                              ></b-form-input>
                                            </b-input-group>
                                          </b-form-group>
                                          <div align="center" v-if="loaderCertificado">
                                              <b-spinner variant="primary" label="Spinning"></b-spinner>
                                          </div>                                                                                      
                                        </b-col>
                                      </b-row>

                                      <b-row>
                                        <b-col align="left">
                                          <validation-provider
                                            name="compania"
                                            :rules="{ required: true }"
                                            v-slot="motivoSlot"
                                          >
                                            <label>Compañia </label
                                            ><validacion>*</validacion>
                                            <v-select
                                              label="nombreComercial"
                                              id="compania"
                                              v-model="compania"
                                              :options="lstCompania"
                                              @input="seleccinarEmpresa($event)"
                                              required
                                              disabled
                                              :state="
                                                motivoSlot.errors[0]
                                                  ? false
                                                  : motivoSlot.valid
                                                  ? true
                                                  : null
                                              "
                                            >
                                              <span slot="no-options"
                                                >No hay datos...</span
                                              >
                                            </v-select>

                                            <validacion
                                              :texto="
                                                motivoSlot.errors[0]
                                                  ? motivoSlot.errors[0]
                                                  : ''
                                              "
                                            ></validacion>
                                          </validation-provider>
                                        </b-col>
                                        <b-col align="left">
                                          <validation-provider
                                            name="plan_convenio"
                                            :rules="{ required: true }"
                                            v-slot="motivoSlot"
                                          >
                                            <label>Plan Convenio</label
                                            ><validacion>*</validacion>
                                            <v-select
                                              label="nombrePlan"
                                              id="plan_convenio"
                                              v-model="planConvenio"
                                              :options="lstPlanesConvenios"
                                              @input="
                                                seleccinarPlanConvenio($event)
                                              "
                                              required
                                              disabled
                                              :state="
                                                motivoSlot.errors[0]
                                                  ? false
                                                  : motivoSlot.valid
                                                  ? true
                                                  : null
                                              "
                                            >
                                              <span slot="no-options"
                                                >No hay datos...</span
                                              >
                                            </v-select>
                                            <validacion
                                              :texto="
                                                motivoSlot.errors[0]
                                                  ? motivoSlot.errors[0]
                                                  : ''
                                              "
                                            ></validacion>
                                          </validation-provider>
                                        </b-col>
                                      </b-row>
                                      <b-row
                                        ><b-col><p></p></b-col
                                      ></b-row>
                                      <b-row>
                                        <b-col>
                                          <div>
                                            <label>Número de póliza</label>
                                            <b-form-group align="left">
                                              <b-input-group
                                                size="sm"
                                                class="mb-2"
                                              >
                                                <b-input-group-prepend is-text>
                                                  <b-icon
                                                    icon="chat-left-text"
                                                  ></b-icon>
                                                </b-input-group-prepend>
                                                <b-form-input
                                                  disabled
                                                  id="numero_poliza"
                                                  name="numero_poliza"
                                                  placeholder="Número de póliza"
                                                  v-model="form.numeroPoliza"
                                                ></b-form-input>
                                              </b-input-group>
                                            </b-form-group>
                                          </div>
                                        </b-col>
                                        <b-col>
                                          <b-form-group align="left">
                                            <label for="numero_certificado"
                                              >Número de certificado</label
                                            >
                                            <b-input-group
                                              size="sm"
                                              class="mb-2"
                                            >
                                              <b-input-group-prepend is-text>
                                                <b-icon
                                                  icon="chat-left-text"
                                                ></b-icon>
                                              </b-input-group-prepend>
                                              <b-form-input
                                                disabled
                                                id="numero_certificado"
                                                name="numero_certificado"
                                                placeholder="Número de certificado"
                                                v-model="form.numeroCertificado"
                                              ></b-form-input>
                                            </b-input-group>
                                          </b-form-group>
                                        </b-col>
                                      </b-row>
                                      <b-row>
                                        <b-col>
                                          <label for="vigencia">Vigencia</label
                                          ><validacion>*</validacion>
                                        </b-col>
                                      </b-row>
                                      <b-row>
                                        <b-col>
                                          <validation-provider
                                            name="vigencia_inicio2"
                                            :rules="{ required: true }"
                                            v-slot="motivoSlot"
                                          >
                                            <b-form-group inline align="left">
                                              Del:
                                              <b-input-group
                                                size="sm"
                                                class="mb-2"
                                              >
                                                <b-input-group-prepend is-text>
                                                  <b-icon
                                                    icon="calendar2-check"
                                                  ></b-icon>
                                                </b-input-group-prepend>
                                                <b-form-datepicker
                                                  disabled
                                                  id="vigencia_inicio2"
                                                  name="vigencia_inicio2"
                                                  placeholder="Fecha inicio"
                                                  v-model="inicioVigencia"
                                                  :state="
                                                    motivoSlot.errors[0]
                                                      ? false
                                                      : motivoSlot.valid
                                                      ? true
                                                      : null
                                                  "
                                                ></b-form-datepicker>
                                              </b-input-group>
                                            </b-form-group>

                                            <validacion
                                              :texto="
                                                motivoSlot.errors[0]
                                                  ? motivoSlot.errors[0]
                                                  : ''
                                              "
                                            ></validacion>
                                          </validation-provider>
                                        </b-col>
                                        <b-col>
                                          <validation-provider
                                            name="vigencia_fin2"
                                            :rules="{ required: true }"
                                            v-slot="motivoSlot"
                                          >
                                            <b-form-group>
                                              Al:
                                              <b-input-group
                                                size="sm"
                                                class="mb-2"
                                              >
                                                <b-input-group-prepend is-text>
                                                  <b-icon
                                                    icon="calendar2-check"
                                                  ></b-icon>
                                                </b-input-group-prepend>
                                                <b-form-datepicker
                                                  disabled
                                                  id="vigencia_fin2"
                                                  name="vigencia_fin2"
                                                  placeholder="Fecha fin"
                                                  v-model="finVigencia"
                                                  required
                                                  :state="
                                                    motivoSlot.errors[0]
                                                      ? false
                                                      : motivoSlot.valid
                                                      ? true
                                                      : null
                                                  "
                                                ></b-form-datepicker>
                                              </b-input-group>
                                            </b-form-group>

                                            <validacion
                                              :texto="
                                                motivoSlot.errors[0]
                                                  ? motivoSlot.errors[0]
                                                  : ''
                                              "
                                            ></validacion>
                                          </validation-provider>
                                        </b-col>
                                      </b-row>

                                      <br />
                                      <b-row align="center">
                                        <b-col v-if="$localStorageService.can('BT_guardar_beneficio')">
                                          <div v-if="!editar">
                                            <b-button
                                              block
                                              variant="success"
                                              type="submit"
                                              v-if="!existePlan"
                                              >Guardar</b-button
                                            >
                                            <b-alert
                                              show
                                              variant="danger"
                                              v-else
                                              >El paciente ya cuenta con el plan
                                              seleccionado</b-alert
                                            >
                                          </div>
                                          <div v-else>
                                            <b-button
                                              variant="success"
                                              block
                                              type="submit"
                                              >Editar</b-button
                                            >
                                          </div>
                                        </b-col>
                                        <b-col v-if="$localStorageService.can('BT_limpiar_beneficio')">
                                          <div>
                                            <b-button
                                              variant="secondary"
                                              block
                                              @click="limpiarFormulario()"
                                              >Limpiar Formulario</b-button
                                            >
                                          </div>
                                        </b-col>

                                        <b-col v-if="$localStorageService.can('BT_Alta_px_beneficio')">
                                          <div>
                                            <router-link
                                              :to="{ name: 'PacienteCu' }"
                                            >
                                              <b-button block variant="primary"
                                                >Alta de paciente</b-button
                                              >
                                            </router-link>
                                          </div>
                                        </b-col>
                                      </b-row>

                                      <br /><br /><br />
                                    </b-form>
                                  </validation-observer>
                                </b-col>
                              </b-row>
                            </b-card-body>
                          </b-card>
                        </b-col>
                      </b-row>
                    </b-tab>
                  </b-tabs>

                <!--   -->
                <b-row>
                  <b-col>
                    <br />
                  </b-col>
                </b-row>
                <!--   -->
              </b-card-body>
            </b-card>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import Header from "@/components/Header";
//import busquedaPaciente from "@/components/NuevaAgenda/nuevaCita/busquedaPaciente";
import miniToastr from "mini-toastr";
import {DatosCita} from "@/components/NuevaAgenda/nuevaCita/DatosCita";
import cardPaciente from "@/views/planes/cardPaciente";

export default {
  name: "asignarEditarPlanConvenioPaciente",
  components: {
    Header,
    //busquedaPaciente,
    cardPaciente
  },
  props: {},
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    listaBusquedaPaciente: [],
    listaPlanesPaciente: [],
    encabezadosPlanesPaciente: [
      {
        key: "aplicarDescuento",
        label: "Aplicar Descuento",
      },
      /*{
        key: "idPaciente",
        label: "Id Paciente",
      },
      {
        key: "registroActivoPaciente",
        label: "Estatus Paciente",
      },*/
      {
        key: "descripcionTipoAsegurado",
        label: "Tipo de Asegurado",
      },
      {
        key: "empresa",
        label: "Nombre Empresa",
      },
      {
        key: "nombreTipoPlan",
        label: "Tipo de Plan",
      },
      {
        key: "descripcionCobertura",
        label: "Cobertura",
      },
      {
        key: "nombrePlan",
        label: "Nombre Plan",
      },
      {
        key: "registroActivoPlan",
        label: "Estatus del Plan",
      },
      {
        key: "suspendidoPlan",
        label: "Plan Suspedido",
      },
      {
        key: "numeroPoliza",
        label: "Número Póliza",
      },
      {
        key: "certificado",
        label: "Número certificado",
      },
      {
        key: "vigenciaSeleccionada",
        label: "Vigencia Seleccionada",
      },
      /*{
        key: "inicioVigenciaPaciente",
        label: "Fecha Inicio de vigencia Paciente",
        sortable: true,
      },
      {
        key: "finvigenciaPaciente",
        label: "Fecha Fin de vigencia Paciente",
        sortable: true,
      },*/
      {
        key: "inicioVigenciaPlan",
        label: "Fecha Inicio de vigencia Plan",
        sortable: true,
      },
      {
        key: "finvigenciaPlan",
        label: "Fecha Fin de vigencia Plan",
        sortable: true,
      },
      /*{
        key: "fechaModificacion",
        label: "Fecha Modificación",
        sortable: true,
      },
      {
        key: "nombreUsuarioModificacion",
        label: "Usuario Modificación",
      },
      {
        key: "registroActivoPacientePlan",
        label: "Activar/Inactivar Plan Paciente",
      },
      {
        key: "editar",
        label: "Editar",
      },*/
      {
        key: "acciones",
        label: "Acciones"
      }
    ],
    form: {
      idCompania: null,
      numeroPoliza: null,
      numeroCertificado: null,
      idPaciente: null,
      idBeneficioCorporativo: null,
      inicioVigencia: null,
      finVigencia: null,
      idPlan: null,
      idUsuario: null,
      idTipoAsegurado: null,
      idClinica: null
    },
    existePlan: false,
    inicioVigencia: null,
    finVigencia: null,
    loaderCertificado: false,
    listaTipoAsegurado: [],
    plan_convenio: false,
    spinner: false,
    activar_inactivar: null,
    editar: false,
    tipoAsegurado: null,
    loading: false,
    proceso: 1,
    lstPolizasConvenios: [],
    poliza: null,
    paciente: null,
    controladorTiempo: null,
    compania: null,
    certificado: null,
    lstCompania: [],
    planConvenio: null,
    lstPlanesConvenios: [],
    tipo_poliza: 1,
    resultado: null,
    datosCita: null,
    nombrePacienteBusqueda: null,
    loadingPacientes: false,
    registros: null,
    columnasPacientesEncontrados: [
      {key: "id", label: "Id paciente", sortable: true},
      {key: "nombre", label: "Nombre paciente", sortable: true},
      {key: "fechaNacimiento", label: "Fecha Nacimiento", sortable: true},
    ],
    pacSelTmp: null,
    mostrarBarraBusqueda: true,
    asignacionPlanModal: false,
    plan: null,
    planesSinHerramientas: []
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  mounted() {
    this.obtenerListaEmpresas();
    this.obtenerTipoAsegurado();
  },
   computed: {
  
     buscarPlanSinHerramientas() {
      return (planId) => {
        return this.planesSinHerramientas.find(a => a.idPlan === planId) || null;
      };
   }
  },
  methods: {
    planEstaVigente(inicio, fin) {
      
    const hoy = new Date();

    const inicioDate = new Date(inicio);
    const finDate = new Date(fin);
    return hoy >= inicioDate && hoy <= finDate;
  },
    /**
     * Obtener el select del paciente
     * @param paciente
     */
    seleccinarPaciente(paciente) {
      if(paciente.idPaciente != null){
        this.form.idPaciente = paciente.idPaciente;
      }else{
        this.form.idPaciente = paciente.id;
      }
      this.existePlan = false;
      //buscamos los planes del paciente
      this.getBuscarPlanesPaciente();
      this.limpiarFormulario();
    },

    getBuscarPacienteServicio(search, loading) {
      loading(true);
      clearTimeout(this.controladorTiempo);
      this.controladorTiempo = setTimeout(() => {
        const params = {
          nombrePaciente: search
        }
        this.$http
          .post(
            this.$api +
              "paciente/perfiles/obtenerpacientes/activos", params)
          .then((response) => {
            if (response.data.data) {
              this.listaBusquedaPaciente = [];
              let resultado = response.data.data;
              resultado.forEach((item, index) => {
                item.id = index;
                this.listaBusquedaPaciente.push(item);
              });
              loading(false);
            }
          })
          .catch(function (error) {
            console.error(error);
            loading(false);
            this.$swal({
              icon: "error",
              text: "A ocurrido un error, intentalo más tarde.",
              confirmButtonText: "OK",
              confirmButtonColor: "#0e6ba9",
            });
          });
        clearTimeout(this.controladorTiempo);
      }, 1000);
    },
    
   async getBuscarPlanesPaciente() {
  this.loading = true;
  this.spinner = true;

  try {
    if (this.form.idPaciente == null) {
      this.loading = false;
      this.spinner = false;
      return;
    }

    this.listaPlanesPaciente = [];

    const param = {
      idPaciente: this.form.idPaciente
    };

    const response = await this.$http.post(
      this.$api + "paciente/perfiles/obtenerPlanesPaciente/detalles",
      param
    );

    if (response.data.data) {
      this.listaPlanesPaciente = response.data.data;

      await this.obtenerPlanSinHerramientas();
    }

  } catch (error) {
    console.error(error);

    this.$swal({
      icon: "error",
      text: error?.response?.data?.message || "Error inesperado",
      confirmButtonText: "OK",
      confirmButtonColor: "#0e6ba9",
    });

  } finally {
    this.loading = false;
    this.spinner = false;
  }
},

    obtenerPlanSinHerramientas(){
        
        const listPlanes =[];
        listPlanes.push(...this.listaPlanesPaciente.map(p => p.idPlan));

        const parametros = {
        idPlanes: listPlanes
      };

      this.$http.post(this.$api + "planPaciente/obtener/planesSinHerramientas", parametros)
      .then((response) => {
         const respuesta = response.data.data;
         this.planesSinHerramientas = respuesta;
           });
      
    },

    /**
     * obtener la lista de empresas
     */
    obtenerListaEmpresas() {
      const parametros = {estatus: true}
      var url = "empresas/obtener/empresasconplanes/porestatus";
      if (this.proceso == 2) {
        url = "empresas/obtener";
      }

      this.$http
        .post(this.$api + url, parametros)
        .then((response) => {
          if (response.data.data) {
            let resultado = response.data.data;
            this.lstCompania = [];
            resultado.forEach((item, index) => {
              item.id = index;
              this.lstCompania.push(item);
              
            });
          }
        })
        .catch(function (error) {
          console.error(error);
          this.$swal({
            icon: "error",
            text: "A ocurrido un error, intentalo más tarde.",
            confirmButtonText: "OK",
            confirmButtonColor: "#0e6ba9",
          });
        });
    },
    /**
     * Obtener lista de los planes
     * @param empresa
     */
    obtenerPlanesEmpresa(empresa) {
      this.planConvenio = null;
      const parametros = {idEmpresa: empresa.idEmpresa, estatus: true}
      var url = "empresas/obtener/planes/porestatus/sinpoblacion";
      if (this.proceso == 2) {
        url = "empresas/obtener/beneficios/empresa?idEmpresa=";
      }

      this.$http
        .post(this.$api + url, parametros)
        .then((response) => {
          if (response.data.data) {
            let resultado = response.data.data;
            this.lstPlanesConvenios = [];
            resultado.forEach((item, index) => {
              item.id = index;
              this.lstPlanesConvenios.push(item);
            });
          }
          if (this.lstPlanesConvenios.length <= 0) {
            this.blnRegistros = true;
          }
        })
        .catch(function (error) {
          console.error(error);
          this.$swal({
            icon: "error",
            text: "A ocurrido un error, intentalo más tarde.",
            confirmButtonText: "OK",
            confirmButtonColor: "#0e6ba9",
          });
        })
        .finally(() => {
          this.plan_convenio = true;
        });
    },

    obtenerTipoAsegurado() {
      this.$http
        .get(this.$api + "catalogos/planpaciente/tipoAsegurado")
        .then((response) => {
          if (response.data.data) {
            let resultado = response.data.data;
            this.listaTipoAsegurado = [];
            resultado.forEach((item, index) => {
              item.id = index;
              this.listaTipoAsegurado.push(item);
            });
          }
        })
        .catch(function (error) {
          console.error(error);
          this.$swal({
            icon: "error",
            text: "A ocurrido un error, intentalo más tarde.",
            confirmButtonText: "OK",
            confirmButtonColor: "#0e6ba9",
          });
        });
    },

    obtenerCertificado() {
      this.loaderCertificado = true;
      const parametros = {certificado: this.certificado}
      this.$http
        .post(this.$api + "planConvenio/convenio/obtenercertificado", parametros)
        .then((response) => {
          if (response.data.data) {
            this.resultado = response.data.data;
            this.seleccinarCertificado(this.resultado)            
          }
        })
        .catch((error) =>{
          var message = error.response.data.message
                ? error.response.data.message
                : "A ocurrido un error, intentalo más tarde.";
          this.$swal.fire({
            icon: "info",
            text: message,
            confirmButtonText: "OK",
            confirmButtonColor: "#0e6ba9",
          });
        })
        .finally(() => this.loaderCertificado = false);
    },
    /**
     * obtener la impresa seleccionada
     * @param evento
     */
    seleccinarEmpresa(evento) {
      if (evento != null) {
        this.lstPlanesConvenios = [];
        this.planConvenio = null;
        this.plan_convenio = false;
        this.form.idCompania = evento.idEmpresa;       
        this.obtenerPlanesEmpresa(evento);
      } else {
        this.compania = null;
        this.lstPlanesConvenios = [];
        this.planConvenio = null;
        this.plan_convenio = false;
        this.form.idCompania = null;
      }
    },
    storageSource(){
      localStorage.procedencia = 2;
    },
    /**
     * Obtener el convenio seleccionado
     * @param evento
     */
    seleccinarPlanConvenio(evento) {
      if (evento != null) {
        this.existePlan = false;
        this.form.idPlan = evento.idPlan;
        this.validarPlanConvenioExistente();
        if (this.proceso == 1) {
            if (evento.fechaInicio != null && evento.fechaInicio != "") {
            this.inicioVigencia = this.$moment(evento.fechaInicio).format("YYYY-MM-DD");
          }
            if (evento.fechaFin != null && evento.fechaFin != "") {
            this.finVigencia = this.$moment(evento.fechaFin).format("YYYY-MM-DD");
          }
        }
        /*if (this.proceso == 2) {
          this.seleccinarPolizaTipo(this.tipo_poliza);
        } */
      } else {
        this.planConvenio = null;
        this.existePlan = false;
        this.form.idPlan = null;
        this.inicioVigencia = null;
        this.finVigencia = null;
      }
    },

    seleccinarCertificado(evento) {
      
      if (evento != null && evento != "") {
        this.proceso = 2;
        this.form.idBeneficioCorporativo = evento.idBeneficioCorporativo;
        this.form.idCompania = evento.idEmpresa;
        this.form.idPlan = evento.idPlan;
        this.compania = evento.nombreComercial;
        this.seleccinarEmpresa(evento);
        this.seleccinarPlanConvenio(evento);
        this.form.numeroPoliza = evento.poliza;
        this.form.numeroCertificado = evento.certificado;
        this.form.idTipoAsegurado = 2;
        this.planConvenio = evento.nombrePlan;
        //this.certificado = evento.certificado;
        this.inicioVigencia = this.$moment(evento.fechaInicio).format("YYYY-MM-DD");
        this.finVigencia = this.$moment(evento.fechaFin).format("YYYY-MM-DD");
        
      } else {
       this.limpiarFormulario();
      }
    },

    seleccinarTipoAsegurado(evento) {
      this.proceso = 1; 
      this.form.idTipoAsegurado = evento.idTipoAsegurado;
    },

    guardarPlanPaciente() {  
        this.form.idUsuario = this.$localStorageService.getIdUsuario();
        this.form.idClinica = this.$localStorageService.getIdClinica();
        this.form.inicioVigencia = this.inicioVigencia;
        this.form.finVigencia = this.finVigencia;
        // this.form.inicioVigencia = this.$moment(this.inicioVigencia).utc();
        // this.form.finVigencia = this.$moment(this.finVigencia).utc();
        var url = "";
        var mensaje = "";
        var mensajeFalse = "";
 
      if (!this.editar) {
        this.validarPlanConvenioExistente();
        if (this.proceso == 1) {
          url = "planConvenio/paciente/planesconvenio/guardar";
        }else{
          url = "planConvenio/paciente/planconvenio/corporativo/guardar"
        }
        mensaje = "Datos guardados correctamente";
        mensajeFalse = "No se pudo guardar, verifique datos ingresados";
      } else {
        this.existePlan = false;
        if(this.proceso == 1){
          url = "planConvenio/paciente/planesconvenio/editar";
        } else{
          url = "planConvenio/paciente/planconvenio/corporativo/editar"
        }

        mensaje = "Datos editados correctamente";
        mensajeFalse = "No se pudo editar, verifique datos ingresados";
      }
      if (this.existePlan == false) {
        this.loading = true;
        this.$http
          .post(this.$api + url, this.form)
          .then((response) => {
            if (response.data.data == true) {
              this.$swal({
                icon: "success",
                text: mensaje,
                confirmButtonText: "OK",
                confirmButtonColor: "#0e6ba9",
              });
              this.getBuscarPlanesPaciente();
              this.limpiarFormulario();
              this.asignacionPlanModal = false;
            } else {
              this.$swal({
                icon: "error",
                text: mensajeFalse,
                confirmButtonText: "OK",
                confirmButtonColor: "#0e6ba9",
              });
            }
          })
          .catch((error) => {
            var message = error.response.data.message
                ? error.response.data.message
                : "A ocurrido un error, intentalo más tarde.";
            this.$swal({
              icon: "error",
              text: message,
              confirmButtonText: "OK",
              confirmButtonColor: "#0e6ba9",
            });
          })
          .finally(() => (this.loading = false));
      }
    },

    validarPlanConvenioExistente() {
      this.listaPlanesPaciente.forEach((elemento) => {
        if (elemento.idPlan == this.form.idPlan) {
          this.existePlan = true;
        }
      });
    },

    /**
     * Cambiar el estatus del plan del paciente
     * @param boolean
     */
    cambiarEstatusPlanPaciente(idPlanPaciente, boolean) {
      var mensaje = "";
      if (boolean) {
        mensaje = "ACTIVAR";
      } else {
        mensaje = "INACTIVAR";
      }

      var idUsuario = this.$localStorageService.getIdUsuario();
      this.$swal
        .fire({
          title: "¿Desea " + mensaje + " el paciente?",
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: "Continuar",
          cancelButtonText: "Cancelar",
        })
        .then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.loading = true;
            this.$http
              .put(
                this.$api +
                  "planConvenio/paciente/planesconvenio/actualizarestatus?idPlanPaciente=" +
                  idPlanPaciente +
                  "&estatus=" +
                  boolean +
                  "&idUsuario=" +
                  idUsuario,
                this.form
              )
              .then((response) => {
                this.$swal({
                  icon: "success",
                  text: response.data.message,
                  confirmButtonText: "OK",
                  confirmButtonColor: "#0e6ba9",
                });

                this.getBuscarPlanesPaciente();
              })
              .catch((error) => {
                console.error(error);
                this.$swal({
                  icon: "error",
                  text: "A ocurrido un error, intentalo más tarde.",
                  confirmButtonText: "OK",
                  confirmButtonColor: "#0e6ba9",
                });
              })
              .finally(() => (this.loading = false));
          }
        });
    },
    /**
     * Editar datos del plan del paciente
     * id de la tabla plan tratamiento
     * @param idTablaPlanTratamiento
     */
    editarPlanPaciente(idTablaPlanTratamiento) {
      this.editar = true;

      this.listaPlanesPaciente.forEach((elemento) => {
        if (elemento.id == idTablaPlanTratamiento) {
          this.compania = elemento.empresa;
          this.planConvenio = elemento.nombrePlan;
          if(elemento.inicioVigenciaPaciente != null){
            this.inicioVigencia = this.$moment(elemento.inicioVigenciaPaciente).format(
              "YYYY-MM-DD"
            );
          }
          if(elemento.finvigenciaPaciente != null){            
            this.finVigencia = this.$moment(elemento.finvigenciaPaciente).format(
              "YYYY-MM-DD"
            );
          }
          this.tipoAsegurado = elemento.descripcionTipoAsegurado;

          this.form.idTipoAsegurado = elemento.idTipoAsegurado;
          this.form.idCompania = elemento.idEmpresa;
          this.form.numeroPoliza = elemento.numeroPoliza;
          this.form.numeroCertificado = elemento.certificado;
          this.form.idPaciente = elemento.idPaciente;
          this.form.inicioVigencia = elemento.inicioVigenciaPaciente;
          this.form.finVigencia = elemento.finvigenciaPaciente;
          this.form.idPlan = elemento.idPlan;
          this.form.idUsuario = this.$localStorageService.getIdUsuario();
        }
      });
      this.asignacionPlanModal = true;
    },

    limpiarFormulario() {
      this.certificado = null;
      this.compania = null;
      this.planConvenio = null;
      this.inicioVigencia = null;
      this.finVigencia = null;
      this.tipoAsegurado = null;
      this.form.idCompania = null;
      this.form.numeroPoliza = null;
      this.form.numeroCertificado = null;
      this.form.inicioVigencia = null;
      this.form.finVigencia = null;
      this.form.idPlan = null;
      this.form.idUsuario = null;
      this.form.idTipoAsegurado = null;
      this.editar = false;
      this.poliza = null;
      this.resultado = null
    },

    /**
     * Seleccionar opcion plan o convenio
     */
    opcion(plan_o_convenio) {
      // proceso = 1 -> plan
      // proceso = 2 -> convenio
      this.proceso = plan_o_convenio;
      this.limpiarFormulario();
      this.obtenerListaEmpresas();
    },

    /**
     * Obtener lista de los planes
     * @param empresa
     */
    obtenerPolizasPlan(idPlan) {
      this.lstPolizasConvenios = [];

      const parametros = {idPlan: idPlan}
      this.$http
        .post(this.$api + "planConvenio/obtener/polizas", parametros)
        .then((response) => {
          if (response.data.data) {
            this.lstPolizasConvenios = response.data.data;

            // let resultado = response.data.data;
            // this.lstPolizasConvenios = [];
            // resultado.forEach((item, index) => {
            //   item.id = index;
            //   this.lstPolizasConvenios.push(item);
            // });
          }
          if (this.lstPolizasConvenios.length <= 0) {
            this.blnRegistros = true;
          }
        })
        .catch(function (error) {
          console.error(error);
        });
    },

    seleccinarPolizaLista(evento) {
      this.form.numeroPoliza = evento.descripcion;
    },

    seleccinarPolizaTipo(evento) {
      //1 - Capturar
      //2 - Buscar
      if (evento != null) {
        if (evento == 2) {
          this.obtenerPolizasPlan(this.form.idPlan);
        }
      }
    },
    /*seleccionarPaciente(datosCita) {
      this.datosCita.idPaciente = datosCita.idPaciente;
      this.datosCita.nombrePaciente = datosCita.nombrePaciente;
      this.datosCita.esPacienteNuevo = datosCita.idTipoPaciente == 1;
      this.datosCita.idTipoPaciente = datosCita.idTipoPaciente;
      this.datosCita.tipoPaciente = datosCita.tipoPaciente;
      this.datosCita.idSexo = datosCita.idSexo;
      this.datosCita.celular = datosCita.telefono;
      this.datosCita.correo = datosCita.correo;
      this.datosCita.ptiActivo = datosCita.ptiActivo;
      this.datosCita.fechaNacimientoCompleta = datosCita.fechaNacimientoCompleta;
      this.datosCita.confianza = datosCita.confianza;
      this.datosCita.ultimoTratamiento = datosCita.ultimoTratamiento;

      this.deshabilitarTodo = false;

      if (this.datosCita.citaEdicion === undefined
        || this.datosCita.citaEdicion === null || !this.datosCita.citaEdicion) {
        this.datosCita.idTagMotivoCita = null;
      }

    },*/
    async seleccionarPaciente(item) {
      this.pacSelTmp = item;

      this.submitSelPaciente();
    },
    submitSelPaciente () {
      this.mostrarBarraBusqueda = false;
      this.nombrePacienteBusqueda = null;
      this.registros = null;
      //window.scrollTo(0, 0);

      this.datosCita = new DatosCita();
      this.datosCita.idPaciente = this.pacSelTmp.id;
      this.datosCita.nombrePaciente = this.pacSelTmp.nombre;
      this.datosCita.esPacienteNuevo = this.pacSelTmp.idTipoPaciente == 1;
      this.datosCita.idTipoPaciente = this.pacSelTmp.idTipoPaciente;
      this.datosCita.tipoPaciente = this.pacSelTmp.tipoPaciente;
      this.datosCita.idSexo = this.pacSelTmp.idSexo;
      this.datosCita.celular = this.pacSelTmp.telefono;
      this.datosCita.correo = this.pacSelTmp.correo;
      this.datosCita.fechaNacimientoCompleta = this.pacSelTmp.fechaNacimientoCompleta;
      this.datosCita.registroActivo = this.pacSelTmp.registroActivo;

      this.seleccinarPaciente(this.pacSelTmp);

    },
    buscarPacientes() {

      if (this.validarInputBusqueda()) {
        console.error("No se puede buscar por validacion de numeros letras")
        return;
      }

      this.pacSelTmp = null;
      this.mostrarAdvertencia = false;

      if (this.loadingPacientes) {
        return;
      }

      this.registros = Array();
      this.paginaActual = 1;
      if (
          this.nombrePacienteBusqueda === undefined ||
          this.nombrePacienteBusqueda === null ||
          this.nombrePacienteBusqueda.length < 4
      ) {
        return;
      }

      const inputTxt = this.nombrePacienteBusqueda
          .trim()
          .toUpperCase();

      this.loadingPacientes = true;
      const parametros = {datoBuscar: inputTxt}
      this.$http
          .post(
              this.$api +
              "paciente/perfiles/buscarPacienteMin", parametros
          )
          .then((response) => {
            if (response.status === 200) {


              if (Array.isArray(response.data.data)) {
                this.registros = response.data.data;

                this.registros.forEach(e => {
                  e.color = e.idTipoPaciente==1?'white':'#00aa33'
                });

                if (Array.isArray(this.registros)) {
                  this.registros.sort(function (a, b) {
                    if (a.id > b.id) {
                      return 1;
                    }
                    if (a.id < b.id) {
                      return -1;
                    }
                    return 0;
                  });
                }
              }
            }
          })
          .catch((error) => {
            miniToastr.info("No se encontraron pacientes");
            console.error("Error", error);
            this.loadingPacientes = false;
          })
          .finally(() => {
            this.loadingPacientes = false;
          });
      },
      validarInputBusqueda() {
      if (this.nombrePacienteBusqueda !== undefined
          && this.nombrePacienteBusqueda !== null
          && this.nombrePacienteBusqueda !== '') {

        const contieneNumerosLetras =  /[A-Za-z]/.test(this.nombrePacienteBusqueda);
        const contieneNumeros = /[0-9]/.test(this.nombrePacienteBusqueda);
        return contieneNumerosLetras && contieneNumeros;
      }

      return false;
    },
    mandarDatos(datos){
      console.error("datos",datos)
      this.plan = datos;
    },
  },
  watch: {
 
  }
};
</script>

<style scoped>
</style>
